import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import { isCurrentLanguageRtl } from 'modules/language/selectors/language';
import { Icon, MaterialHint } from 'shared/components';
import { useTrappedFocus } from 'shared/hocs/useTrappedFocus';

import theme from './MediaViewControl.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({

      icon: PropTypes.string.isRequired,
      title: PropTypes.shape({
        id: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string.isRequired,
      }).isRequired,
      onClick: PropTypes.func.isRequired,

    }).isRequired,
  ).isRequired,
  isExpanded: PropTypes.bool.isRequired,
};

const defaultProps = {};

const MediaViewControl = ({ intl, actions, allowedActions, isExpanded }) => {
  const focusContainerRef = useTrappedFocus();

  return (
    <div
      ref={ focusContainerRef }
      className={ classnames(theme.root, {
        [theme.fullscreen]: isExpanded,
      }) }
    >
      <div className={ theme.controlContainer }>
        { actions.filter(action => allowedActions.includes(action.name)).map((action) => (
          <div
            className={ classnames(theme.button, {
                [theme.closeButton]: action.name === 'CLOSE',
                [theme.deleteButton]: action.name === 'DELETE',
              }) }
            key={ action.icon }
          >
            { action.name === 'CLOSE' && (
            <button onClick={ action.onClick } aria-label={ intl.formatMessage(action.ariaLabel) }>
              <Icon name={ action.icon } />
              <span className={ theme.title }>
                { intl.formatMessage(action.title) }
              </span>
            </button>
              ) }

            { action.name !== 'CLOSE' && (
            <MaterialHint
              title={ intl.formatMessage(action.title) }
              placement={ isCurrentLanguageRtl() ? 'left' : 'right' }
            >
              <button onClick={ action.onClick } aria-label={ intl.formatMessage(action.title) }>
                <Icon name={ action.icon } />
              </button>
            </MaterialHint>
              ) }
          </div>
          ),
        ) }
      </div>
    </div>
  );
};

MediaViewControl.propTypes = propTypes;
MediaViewControl.defaultProps = defaultProps;

export default memo(injectIntl(MediaViewControl));
